import logger from './logger.js';
/**
 * 
 * @param {number} modelYear Car model year
 * @param {number} mileage  Car mileage
 * @returns {boolean} false if car is non-contender
 */
export function checkNonContender(modelYear, mileage, enginePower, fuelType, price_prediction) {

    // Defaults
    const nonContendersDefault = {
        minAge: 0,
        maxAge: 1000000,
        minMileage: 0,
        maxMileage: 1000000,
        fuelType: '',
        minHp: 0,
        minPrice: 0,
    };

    // Rules
    const nonContenders = [
        { 
            minAge: 10,
            maxAge: 12,
            minMileage: 16000,
        },
        {
            maxAge: 10,
            minMileage: 20000,
        },
        {
            minAge: 12
        },
        // {
        //     fuelType: 'El',
        //     minPrice: 300000
        // },      
        {
            minHp: 550
        },
        {
            minPrice: 600000
        },
      

    ]

    //
    return nonContenders.some( (condition) => {
        const comparative = {...nonContendersDefault, ...condition};
        const year = new Date().getFullYear();
        logger(`Check that modelYear, ${modelYear}  is beteen ${year - comparative.minAge} and ${year - comparative.maxAge}, and mileage, ${mileage} is between ${comparative.minMileage} and ${comparative.maxMileage}`);
        logger(`Check fuelType, ${fuelType} is ${comparative.fuelType} or null`);
        logger(`Check enginePower, ${enginePower} > ${comparative.minHp}`);
        logger(`Check price prediction, ${price_prediction} > ${comparative.minPrice}`);

        if(modelYear <= (year - comparative.minAge)) {logger('minAge: TRUE');} else { logger('minAge: FALSE');}
        if(modelYear >= (year - comparative.maxAge)) {logger('maxAge: TRUE');} else { logger('maxAge: FALSE');}
        if(mileage >= comparative.minMileage) {logger('minMilage: TRUE');} else { logger('minMilage: FALSE');}
        if(mileage <= comparative.maxMileage) {logger('maxMilage: TRUE');} else { logger('maxMilage: FALSE');}
        if(comparative.fuelType === '' || fuelType === comparative.fuelType) {logger('fuelType: TRUE');} else { logger('fuelType: FALSE');}
        if(enginePower >= comparative.minHp) {logger('minHp: TRUE');} else { logger('minHp: FALSE');}
        if(price_prediction >= comparative.minPrice) {logger('minPrice: TRUE');} else { logger('minPrice: FALSE');}

        

        if( 
            modelYear <= (year - comparative.minAge) && 
            modelYear >= (year - comparative.maxAge) && 
            mileage >= comparative.minMileage && 
            mileage <= comparative.maxMileage &&
            (comparative.fuelType === '' || fuelType === comparative.fuelType) &&
            enginePower >= comparative.minHp &&
            price_prediction >= comparative.minPrice
        ) {
            logger('Car is non-contender');
            return true;
        } else {
            logger('Car is a contender');
            return false;
        }
    })
}